<template>
  <div id="side-navbar">
    <header>
      <router-link to="/">
        <div class="title">Profiles <span>by Mobivia Database</span></div>
      </router-link>
    </header>
    <div class="content">
      <div v-for="search in searches" :key="search.rowId">
        <side-search
          :search="search"
          @addFilter="onAddFilter"
          @removeFilter="onRemoveFilter"
          @removeCategorie="onRemoveCategorie"
          @removeValue="onRemoveValue"
          @changeBusinessUnit="onChangeBusinessUnit"
          :businessUnits="businessUnits">
        </side-search>
      </div>

      <div id="add-new-search" class="input-search" @click="addNewSearch" v-show="searches.length < 3">
        <div class="icon-container">
          <div class="icon plus"></div>
        </div>
        <div>{{$t('sideNavbar.compareNewSearch')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import SideSearch from './SideSearch.vue'
  export default {
    name: 'SideNavbar',
    components: {
      SideSearch
    },
    props: {
      searches: Array, 
      businessUnits: Array
    },
    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      addNewSearch() {
        this.$emit('addNewSearch')
      },
      onAddFilter(search_id) {
        this.$emit('addFilter', search_id)
      },
      onRemoveFilter(search_id, findex) {
        this.$emit('removeFilter', search_id, findex)
      },
      onRemoveCategorie(search_id, type, findex, cindex) {
        this.$emit('removeCategorie', search_id, type, findex, cindex)
      },
      onRemoveValue(search_id, type, findex, cindex, iindex) {
        this.$emit('removeValue', search_id, type, findex, cindex, iindex)
      },
      onChangeBusinessUnit(businessUnit) {
        this.$emit('changeBusinessUnit', businessUnit)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/side_navbar.sass"
</style>
